import { CryptoPayoutStatus } from 'types/cryptoPayout';
import { CurrencyCode } from 'types/currency';

import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'pages.cryptoPayout.details.payout';

const LABELS = makeLabels(
  {
    TITLE: ['title', 'Payout'],
    UUID: ['uuid', 'Payout ID'],
    EXTERNAL_PAYOUT_ID: ['externalPayoutId', 'External Payout ID'],
    DOWNLOAD: ['download', 'Download'],
    RECEIPT: ['receipt', 'Receipt'],
    AMOUNT: ['amount', 'Payout total'],
    PDF_FILE_NAME: ['csvFileName', 'crypto-payout-{{uuid}}-receipt.pdf'],
    PDF_DOWNLOAD_ERROR: ['pdfDownloadError', 'Error occured on receipt download'],
    MERCHANT_NAME: ['merchantName', 'Merchant Name'],
    CREATION_TIME: ['creationTime', 'Creation Time'],
    STATUS: ['status', 'Status'],
    PROCESSING_FEE: ['processingFee', 'Processing Fee %'],
    PROCESSING_FREE_AMOUNT: ['processingFeeAmount', 'Processing Fee Amount'],
    NETWORK_FEE: ['networkFee', 'Network Fee'],
    CANCEL: ['cancel', 'Cancel'],
    CANCEL_ERROR: ['cancelError', 'Error occured on payout cancellation'],
  },
  NAMESPACE,
);

export const KEYS = {
  SUCCESSFUL_STATUSES: [CryptoPayoutStatus.Completed],
  // We support only USD for crypto payouts
  HARDCODED_CURRENCY: CurrencyCode.USD,
};

export default LABELS;
